/** @format */

import { ICartItem } from './cart-item.interface';

export interface ICartPage {
  contents: ICartItem[];
  label: string;
}

export interface CartAction {
  action: string;
  message: string;
  product: CartActionProduct;
  reason: string;
}

export interface CartActionProduct {
  ecode: string;
  name: string;
  path: string;
  previous_idx: number;
  qty: number;
  sku: string;
}

export type ScorecardPlusTncStatus = 'ACCEPTED' | 'EXPIRED' | 'NOT_ACCEPTED' | 'SERVICE_ERROR';

export interface ScorecardPlus {
  tncStatus?: ScorecardPlusTncStatus;
}

export interface ICart {
  actions?: CartAction[];
  contents: ICartItem[];
  count: number;
  error?: string;
  message?: string;
  messaging: string[];
  owner: string;
  pages?: ICartPage[];
  path?: string;
  paypalable: boolean;
  status?: number;
  timeToLive: string;
  total: string;
  scorecardPlusMember?: boolean;
  containsScorecardPlusProduct?: boolean;
  scorecardPlus?: ScorecardPlus;
}
